import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/docgen/invoice'
import pathMap from 'src/paths/pathMap'

class InvoiceRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.INVOICE_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.INVOICE_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.INVOICE_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.INVOICE_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default InvoiceRoute
